import MinimalHeader from '../components/Layout/MinimalHeader';

/**
 * MinimalLayout — layout para fluxos de auth (login, registro, recuperar senha).
 * Inclui MinimalHeader simples (sem CTAs, sem sticky).
 */
export function MinimalLayout({ children }) {
  return (
    <>
      <MinimalHeader />
      <main>{children}</main>
    </>
  );
}
